import * as React from "react";

export const IconBusinessReportLine = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="24" height="24" viewBox="24 8 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M27 29V27L29 25V29H27ZM31 29V23L33 21V29H31ZM35 29V21L37 23.025V29H35ZM39 29V23.025L41 21.025V29H39ZM43 29V19L45 17V29H43ZM27 23.825V21L34 14L38 18L45 11V13.825L38 20.825L34 16.825L27 23.825Z"
      fill="currentColor"
    />
  </svg>
);
